import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IProduktionsmallPrimaryKey } from "./ProduktionsmallBaseCommand";
export abstract class ProduktionsmallHandelssortimentBaseCommand extends BasicCommand<ProduktionsmallHandelssortimentBaseCommand> {
    produktionsmallGuid: string;
    handelssortimentId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ProduktionsmallHandelssortiment";

    get primaryKey(): IPrimaryKey<IProduktionsmallHandelssortimentPrimaryKey> {
        return {
            produktionsmallGuid: this.produktionsmallGuid,
            handelssortimentId: this.handelssortimentId
        };
    }

    constructor($type: string, commandType: CommandType) {
        super($type, ProduktionsmallHandelssortimentBaseCommand.$groupKey, commandType);
    }
}

export interface IProduktionsmallHandelssortimentPrimaryKey extends IProduktionsmallPrimaryKey {
    handelssortimentId: number;
}
